/**
 * Auth Layout
 *
 * Centered card layout for auth pages (login, register, forgot-password).
 * Dark background with teal accents.
 */

import { Outlet } from "react-router-dom";

export function AuthLayout() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-[var(--color-bg-primary)] py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full">
        <Outlet />
      </div>
    </div>
  );
}
